<template>
  <nav class="flex items-center justify-between p-4 bg-gray-800 text-white dark:text-gray-200">
    <RouterLink to="/" class="text-lg font-semibold grow ">Vice tracker</RouterLink>
    <div class="flex items-center ml-5">
      <OutboxBadge />
    </div>

    <div class="w-6">
      <GlobeAltIcon
        :class="[
        'transition-colors duration-300', // opțional, pentru animare
        locationStore.updating ? 'text-yellow-400' : 'text-green-600'
      ]"
      ></GlobeAltIcon>
    </div>
    <div class="ml-5">
      <Login />
    </div>
  </nav>
</template>

<script setup>

import { RouterLink } from 'vue-router';
import { GlobeAltIcon } from '@heroicons/vue/24/outline';
import { useLocationStore } from '../stores/locationStore';

import Login from './Login.vue'
import OutboxBadge from './OutboxBadge.vue'

const locationStore = useLocationStore()
</script>
